import { RecipientType } from '../types'

export const validateInvoice = (invoice, t) => {
	const errors = []

	if (!invoice.number?.trim()) {
		errors.push(t('invoices.validation.invoice_number_required'))
	}

	if (invoice.recipient?.type === RecipientType.INDIVIDUAL) {
		if (!invoice.recipient?.person?.firstName?.trim()) {
			errors.push(t('invoices.validation.first_name_required'))
		}

		if (!invoice.recipient?.person?.lastName?.trim()) {
			errors.push(t('invoices.validation.last_name_required'))
		}
	}

	if (invoice.recipient?.type === RecipientType.LEGAL) {
		if (!invoice.recipient?.legal?.name?.trim()) {
			errors.push(t('invoices.validation.company_name_required'))
		}

		if (!invoice.recipient?.legal?.EDRPOU?.trim()) {
			errors.push(t('invoices.validation.tax_id_required'))
		}
	}

	if (!invoice.items?.length) {
		errors.push(t('invoices.validation.item_required'))
	}

	invoice.items?.forEach((item, index) => {
		if (!item.name?.trim()) {
			errors.push(
				t('invoices.validation.service_name_required', { row: index + 1 })
			)
		}
	})

	return errors
}
